import { createTheme, ThemeProvider } from '@material-ui/core';
import { defaultTheme } from '@mvp/design-system';
import React from 'react';

export const CustomMuiTheme: React.FC = ({ children }) => {
  const appTheme = createTheme(defaultTheme);
  return <ThemeProvider theme={appTheme}>{children}</ThemeProvider>;
};
